var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailReciept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60866 16.4167C6.29199 15.6834 7.33366 15.7417 7.93366 16.5417L8.77533 17.6667C9.45033 18.5584 10.542 18.5584 11.217 17.6667L12.0587 16.5417C12.6587 15.7417 13.7003 15.6834 14.3837 16.4167C15.867 18 17.0753 17.475 17.0753 15.2584V5.86669C17.0837 2.50835 16.3003 1.66669 13.1503 1.66669H6.85033C3.70033 1.66669 2.91699 2.50835 2.91699 5.86669V15.25C2.91699 17.475 4.13366 17.9917 5.60866 16.4167Z",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 5.83331H13.3337",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16669H12.5",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailReciept);
export default __webpack_public_path__ + "static/media/mail-reciept.024bc8008f3eae873c67b06e63682999.svg";
export { ForwardRef as ReactComponent };